import { render, staticRenderFns } from "./LoadingStep.vue?vue&type=template&id=c2b3594c&scoped=true&"
import script from "./LoadingStep.vue?vue&type=script&lang=js&"
export * from "./LoadingStep.vue?vue&type=script&lang=js&"
import style0 from "./LoadingStep.vue?vue&type=style&index=0&id=c2b3594c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b3594c",
  null
  
)

export default component.exports